import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import logger from './utils/logger'

// Load browser console scripts
import './scripts/index'

// Debug logging
logger.log('Main.tsx loading...')
logger.log('React mounting started');

try {
  const rootElement = document.getElementById('root');
  logger.log('Root element found:', rootElement);

  if (!rootElement) {
    throw new Error('Root element not found');
  }

  const root = ReactDOM.createRoot(rootElement);
  logger.log('Root created successfully');

  // StrictModeを有効化（開発時の問題検出のため）
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  
  logger.log('React mounting completed');
} catch (error) {
  logger.error('Error mounting React app:', error);
  document.getElementById('root')!.innerHTML = `
    <div style="color: red; padding: 20px;">
      <h1>Error loading application</h1>
      <pre>${error}</pre>
    </div>
  `;
}